import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { StyledEngineProvider } from '@mui/material';

import { BrowserRouter } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import reportWebVitals from './reportWebVitals';
import { queryClient } from './configs/react-query-config';

import { App } from './App';
import './index.css';
import './i18n';
import { SidebarProvider } from './context/SidebarContext';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <StyledEngineProvider injectFirst>
      <HelmetProvider>
        <SidebarProvider>
          <React.StrictMode>
            <BrowserRouter>
              <App />
              <ToastContainer />
            </BrowserRouter>
          </React.StrictMode>
        </SidebarProvider>
      </HelmetProvider>
    </StyledEngineProvider>
    <ReactQueryDevtools />
  </QueryClientProvider>,
  MOUNT_NODE
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
